import { Collapse } from 'antd';

import type { CollapseProps } from 'antd';
import type { FC } from 'react';

type Props = {
  items: CollapseProps['items'];
};

const CollapseAccordion: FC<Props> = (props) => {
  const { items } = props;

  return (
    <Collapse
      accordion
      expandIconPosition="end"
      items={items}
      defaultActiveKey={['0']}
    />
  );
};

export default CollapseAccordion;
